<mat-expansion-panel class="u-margin-bottom-20">
  <mat-expansion-panel-header>
    <mat-panel-title>{{heading}}</mat-panel-title>
  </mat-expansion-panel-header>

  <!-- <div class="metric-settings-content" *ngIf="(loading$ | async); then loadingTemplate; else contentTemplate"></div> -->
  <div class="metric-settings-content" *ngIf="featureEnabled; else featureDisabledTemplate">
    <div *ngIf="(loading$ | async); then loadingTemplate; else contentTemplate"></div>
  </div>

  <ng-template #contentTemplate>
    <app-sports-table
      [sports]="sportRows"
      (toggleChange)="onToggleChange($event)"
      (keyPress)="onKeyPress($event)"
      (paste)="onPaste($event)"
      (inputChange)="onInputChange($event)">
    </app-sports-table>

    <div class="save-button-container">
      <button
        type="submit"
        (click)="onSave()"
        [disabled]="(saving$ | async) || hasValidationErrors()"
        class="percent u-margin-top-50"
        mat-raised-button
        color="primary">Save</button>
    </div>
  </ng-template>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading metric settings...</p>
    </div>
  </ng-template>

  <ng-template #featureDisabledTemplate>
    <div class="metric_settings__try-for-free-container u-margin-top-20 o-flex o-flex--align-items-center o-flex--justify-center u-border-radius border-color u-padding-16 tile-color-background">
      <button color="primary" mat-raised-button (click)="purchaseMetric()">{{tryForFreeText()}}</button>
    </div>
  </ng-template>
</mat-expansion-panel>
